import { themes } from 'kb-shared';
import styled from 'styled-components';

interface Props {
  isRequired?: boolean | null;
}

export const FormText = styled.div<Props>`
  max-width: 700px;
  
  font-size: 28px;
  text-align: left;
  margin: 0px 0px 24px 0px;

  @media screen and ${themes.queries.mobile} {
    font-size: 48px;
  }

  &::after {
    content: "${props => (!!props.isRequired ? '*' : ' ')}";
    color: red;
  }
`;
